<template>
  <div class="icheck" :class="{ 'icheck_chosen': chosen, 'icheck_dropshowed': show }">
    <div class="icheck__icon">
      <slot />
    </div>
    <div class="icheck__body">
      <div class="icheck__headline">
        <h5 class="icheck__title">{{ title }}</h5>
        <div @click.stop.prevent v-if="tooltip" class="icheck__tooltip tooltip tooltip_noclose tooltip_compressed tooltip_inc tooltip_smicon tooltip_wide">
          <div class="tooltip__icon tooltiptrigger">
            <svg viewBox="0 0 20 20">
              <use href="#questionmark3"></use>
            </svg>
          </div>
          <div class="tooltip__body">
            <div class="tooltip__icon tooltip__close tooltiptrigger">
              <svg viewBox="0 0 50 50">
                <use href="#close"></use>
              </svg>
            </div>
            <div class="tooltip__text" v-html="tooltip">
            </div>
          </div>
        </div>
      </div>
      <div class="icheck__select">
        <div class="icheck__inssum" v-if="options.length == 1 || disabled">
          <span class="incheck__inssum-text">{{ inssum }}</span>
        </div>
        
        <button v-else class="icheck__inssum icheck__inssum_pointer" @click.stop="show = !show" v-click-outside="() => show = false">
          <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="rotated">
            <path d="M4 6L8 10L12 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="incheck__inssum-text">{{ inssum }}</span>
          <HiddenField :name="insname" :value="inssum" />
          <Transition name="fastfade">
            <div v-if="options.length && !disabled && show">
              <DropList class="icheck__droplist" :options="options" :modelValue="inssum" @update:modelValue="$emit('update:inssum', $event)" />
            </div>
          </Transition>
        </button>
      </div>
    </div>
    <div class="icheck__tickzone">      
      <div role="checkbox" :aria-checked="chosen" :tabindex="disabled ? false : 0" class="icheck__tick" :class="{ 'icheck__tick_disabled': disabled }" @click="$emit('update:chosen', !chosen)" @keydown.enter.space.stop="$emit('update:chosen', !chosen)">
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 8L6 12L14 2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import DropList from '../DropList.vue';
import HiddenField from '../HiddenField.vue';
import vClickOutside from 'click-outside-vue3'
export default {
  data: () => ({
    show: false,
    tempimmune: false
  }),
  directives: { clickOutside: vClickOutside.directive },
  props: {
    updateAddons: { type: Boolean, default: false },
    tooltip: { type: String, default: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid quod natus perspiciatis ab molestiae cumque laborum iste. Hic, rem itaque." },
    title: { type: String, default: "" },
    options: { type: Array, default: () => [""] },
    prices: { type: Array, default: () => [""] },
    insname: { type: String },
    tickname: { type: String },
    inssum: { type: String },
    chosen: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    name: { type: String, required: true }
  },
  mounted() {
    if (!this.inssum && this.options[0]) {
      this.tempimmune = true
      this.$emit('update:inssum', this.options[0])
      this.$nextTick(()=>this.tempimmune=false)
    }
    window.initTooltips(this.$el)
  },
  computed: {
    priceindex() {
      try {
        return this.options.indexOf(this.inssum)
      } catch (err) {
        return -1
      }
    },
  },
  components: { HiddenField, DropList },
  watch: {
    inssum(v, old) {
      if (v != old && !this.tempimmune)
      this.$store.dispatch('callAction', this.name + '-inssum')
      if(this.chosen)
        this.$store.dispatch('updateAddonsPrice')
    },
    chosen(v, old) {
      if (v != old && !this.tempimmune) {
        this.$store.dispatch('callAction', this.name + '-chosen')
        this.$store.dispatch('updateAddonsPrice')
      }
    },
  }
}
</script>

<style lang="sass" scoped>
.icheck
  box-shadow: 0px 20px 40px rgba(52, 53, 64, 0.1)
  border-radius: 8px
  padding: 15px
  padding-right: 2px
  display: flex
  align-items: center
  color: colors.$gray3
  background: colors.$anothersilver
  transition: background .3s ease-out
  position: relative
  &__droplist
    opacity: 1
    pointer-events: auto
  &_chosen
    background: colors.$mainbg
  &_dropshowed
    z-index: 2
    &:focus-within
      z-index: 3
  &__select
    position: relative
    z-index: 1
  &__icon
    width: 64px
    margin-right: 16px
    position: relative
    z-index: 1
    @include from(500px)
      position: absolute
      margin: 10px 0 0
      left: 50%
      top: 50%
      transform: scale(1.2) translate(-50%, -50%)
      flex-shrink: 0
      filter: blur(2px)
      opacity: .15
      order: 5
      svg
        position: relative
        z-index: -1

  &__headline
    padding-top: 4px
    margin-bottom: 8px
    display: flex
    align-items: center
  &__title
    font-weight: 400
    font-size: 18px
    line-height: 1.12
  &__tooltip
    margin-left: 8px
    transform: translateY(-1px)
  &__inssum
    position: relative
    min-width: 150px
    font-weight: 500
    font-size: 20px
    line-height: 1.18
    display: flex
    align-items: center
    &_pointer
      cursor: pointer
    .aoformdroplist
      top: 0
    svg
      opacity: .5
      stroke: currentColor
      margin-right: 8px
      position: relative
      width: 16px
      margin-top: -4px
      &:not(.rotated)
        transform: scaleY(-1)
  &__tickzone
    flex-basis: 54px
    flex-shrink: 0
    margin-left: auto
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
  &__ticktext
    margin-bottom: 8px
    font-weight: 500
    font-size: 14px
    line-height: 1.12
    width: 99px
  &__tick
    &, *
      outline: none
    position: relative
    transform: translateY(-1px)
    z-index: 1
    &::before
      content: ''
      position: absolute
      top: -15px
      left: -15px
      right: -15px
      bottom: -15px
    display: flex
    justify-content: center
    align-items: center
    width: 24px
    min-width: 24px
    height: 24px
    border: 2px solid colors.$newgray
    cursor: pointer
    transition: border-color .2s ease-out
    &_disabled
      cursor: auto
      pointer-events: none
      border-color: colors.$moar_silver_for_the_god_of_silver2 !important
      svg
        stroke: colors.$moar_silver_for_the_god_of_silver2 !important
    svg
      transition: opacity .2s ease-out
      stroke: colors.$newred
      opacity: 0
    &:hover, &:focus-within
      border-color: colors.$newgray
    &[aria-checked=true]
      border-color: colors.$newgray
      svg
        opacity: 1
</style>